<div class="header">
  <spb-logo routerLink="admin" title="Lånelöfte Admin"/>
  <div [style.flex-grow]="1"></div>
  <spb-toggle-button/>
  @if (configService.currentUser()) {
    <div class="menu-holder">
      <span class="username">{{ configService.currentUser()?.name }}</span>

      <button [matMenuTriggerFor]="menu" matIconButton>
        <mat-icon>menu</mat-icon>
      </button>
    </div>
  }
</div>
<mat-menu #menu="matMenu" class="menu">
  @if (helper.canShowClassic()) {
    <button routerLink="admin/classic" mat-menu-item>Enkla lånelöftet</button>
  }

  @if (helper.canAdminRegistrar()) {
    <button routerLink="admin/register" mat-menu-item>Registrering och översikt
    </button>
  }
  <button (click)="configService.reset()" mat-menu-item>Logga ut</button>
</mat-menu>